import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { forwardRef } from 'react';

import { Link } from '@xing-com/link';

type ButtonElementProps = ComponentPropsWithoutRef<'button'> & {
  as?: ElementType;
};

type RouterButtonElementProps = ComponentPropsWithoutRef<typeof Link> & {
  as?: ElementType;
};

export const ButtonElement = forwardRef<HTMLButtonElement, ButtonElementProps>(
  ({ as: Component = 'button', ...props }, ref) => (
    <Component {...props} ref={ref} />
  )
);

export const RouterButtonElement = forwardRef<
  HTMLAnchorElement,
  RouterButtonElementProps
>(({ as: Component = Link, ...props }, ref) => (
  <Component {...props} ref={ref} />
));
